import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';

import type { FAQNodeProps } from '.';
import getFAQStructuredData from './StructuredData';

/**
 * FAQ node component for the Default display type.
 */

const FAQNodeDefault = (faq: FAQNodeProps) => {
  const { question, answer, anchor } = faq;

  const structuredData = getFAQStructuredData(faq);

  return (
    <BaseContainer id={anchor}>
      <Text as="h4" transform="uppercase">
        {question}
      </Text>
      <RichText value={answer} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </BaseContainer>
  );
};

export default FAQNodeDefault;
